import { GAP_TYPE_META } from '../gap-meta';
import type { GapType } from '../types';

export function GapTypeBadge({ type }: { type: GapType }) {
  const meta = GAP_TYPE_META[type];
  return (
    <span
      className={
        'inline-flex items-center gap-1.5 rounded-full text-xs px-2 py-0.5 font-medium ' +
        meta.badgeClass
      }
    >
      <span className={'w-1.5 h-1.5 rounded-full ' + meta.dotClass} aria-hidden />
      {meta.label}
    </span>
  );
}
